"use client";

import * as React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HeroDeContacto() {
  const {
    ref: heroRef,
    isVisible: heroVisible
  } = useRevealOnScroll<HTMLElement>({
    once: true,
    threshold: 0.2
  });
  return <section ref={heroRef} className="relative w-full min-h-[60vh] flex items-center justify-center overflow-hidden bg-dark-background bg-cover bg-[position:center_30%]\nmd:bg-[position:center_30%] !bg-[url(https://guillermobogao.com/wp-content/uploads/2026/02/CA8BD950-C2BE-48DE-BCB0-511650AB0804.png)] ![padding:8px_0px_8px_0px] !m-0 !opacity-[0.65]">
      
      <div className="relative z-10 max-w-4xl mx-auto px-6 py-20 text-center transition-all duration-[350ms] ease-out translate-y-0 !text-[hsl(0,0%,0%)] !opacity-[1]">
        
        <h1 className="text-4xl font-display font-bold mb-6 !text-[hsl(0,0%,100%)] md:text-5xl lg:text-6xl">
          ¿Listo para recuperar tu claridad?
        </h1>

        
        <p className="text-lg mb-8 max-w-2xl mx-auto !text-[hsl(0,0%,100%)] md:text-xl">Reserva una sesión de exploración gratuita y empecemos a ordenar tu mente, desbloquear lo que te frena y definir el siguiente paso.</p>

        
        <Button asChild size="lg" className="bg-primary text-foreground-primary hover:bg-primary-hover">
  <a href="https://guillermobogao.com/sesion" target="_blank" rel="noopener noreferrer">
    Reserva tu sesión gratuita
  </a>
      </Button>
      </div>

      
      <div className="absolute bottom-0 left-0 right-0 h-px bg-border/40" aria-hidden="true" />
    </section>;
}